/**
 * Donation Product Page Cleanup
 * PTA Shopify Store
 *
 * Hides the "Tax included. Shipping calculated at checkout." line on the
 * donation product page. This is a digital/no-shipping product, so that
 * line doesn't apply.
 *
 * The Quantity selector doesn't need JS - it's hidden via the theme
 * Customizer (eye icon on the Quantity selector block).
 *
 * Add ?dmx-dev-qa to the page URL to see console logging for debugging.
 */

window.addEventListener('load', function () {

  function isDevQAEnabled() {
    return window.location.search.includes('dmx-dev-qa');
  }

  function devQALog(message) {
    if (isDevQAEnabled()) {
      console.log(message);
    }
  }

  function hideShippingNote() {
    // Primary approach: find the shipping-policy link directly.
    let shippingLink = document.querySelector('a[href*="/policies/shipping-policy"]');

    if (shippingLink) {
      const container = shippingLink.closest('p') || shippingLink.parentElement;
      if (container) {
        container.style.display = 'none';
        devQALog('Hid shipping note via shipping-policy link match');
        return;
      }
    }

    // Fallback: search for any element whose text mentions "calculated at
    // checkout" in case this page's markup differs from the shirt page's.
    const candidates = document.querySelectorAll('p, div, span');
    for (const el of candidates) {
      if (el.children.length === 0 && /calculated at checkout/i.test(el.textContent)) {
        el.style.display = 'none';
        devQALog(`Hid shipping note via text-match fallback: "${el.textContent.trim()}"`);
        return;
      }
    }

    devQALog('Shipping note not found by either method - nothing was hidden.');
  }

  devQALog('Donation page cleanup script loaded.');
  hideShippingNote();
});